/**
 * Whose queue the Quality door shows (proposal 12 E2E, kanban 0aac3112):
 * GET /api/quality-copilot/desk. An admin without the quality:copilot scope
 * opens the door as the desk's home person (the quality lead), so the queue
 * matches what the admin sidebar's "Quality desk" entry promises.
 */
import api from './api';

export interface DoorDeskRead {
  home_name: string;
  home_email: string | null;
  /** True when this viewer should see the door as `home_name`'s queue. */
  viewing_as_home: boolean;
}

export async function getDoorDesk(): Promise<DoorDeskRead> {
  const { data } = await api.get<DoorDeskRead>('/quality-copilot/desk');
  return data;
}
